<h2 class="header-major">Edit {{template?.templateName}}</h2>
<app-thought-form *ngIf="template"
  [thought]="template"
  isTemplateForm="true"
  (templateSaved)="templateSaved($event)"
  (templateCancelled)="templateCancelled($event)"
  (templateDeleted)="templateDeleted($event)"></app-thought-form>

